import Link from "next/link"

const steps = [
  {
    title: "1. Request service",
    description:
      "Call us or book online. Tell us the appliance, brand, and what it's doing, and we'll schedule a visit that fits your day, often the same day.",
  },
  {
    title: "2. In-home diagnosis",
    description:
      "An experienced technician tests your appliance on site, finds the root cause, and explains the repair and the price before any work begins.",
  },
  {
    title: "3. Repair and test",
    description:
      "We complete the repair with quality parts, then run the appliance to confirm it's working properly before we leave.",
  },
]

const commonRepairs = [
  { appliance: "Refrigerators", issues: "not cooling, leaking water, ice maker failures, noisy fans" },
  { appliance: "Washers", issues: "won't drain or spin, leaks, error codes, loud during spin" },
  { appliance: "Dryers", issues: "no heat, won't start, long drying times, squeaking drums" },
  { appliance: "Ovens & ranges", issues: "uneven baking, burners not lighting, faulty igniters" },
  { appliance: "Dishwashers", issues: "not draining, dishes not clean, door latch problems" },
]

const towns = [
  "Quincy",
  "Weymouth",
  "Braintree",
  "Milton",
  "Cohasset",
  "Hingham",
  "Hanover",
  "Canton",
  "Rockland",
  "Plymouth",
]

export default function ServiceDetailsSection() {
  return (
    <section aria-labelledby="how-it-works-heading" className="bg-white py-12">
      <div className="container mx-auto max-w-5xl px-4">
        <h2 id="how-it-works-heading" className="text-center text-2xl font-bold text-gray-900 md:text-3xl">
          How Our Appliance Repair Service Works
        </h2>
        <ol className="mt-8 flex flex-col gap-4 md:flex-row">
          {steps.map((step) => (
            <li key={step.title} className="flex-1 rounded-lg border border-gray-200 bg-gray-50 p-5">
              <h3 className="text-base font-bold text-red-700">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-gray-700">{step.description}</p>
            </li>
          ))}
        </ol>

        <div className="mt-12 flex flex-col gap-10 md:flex-row">
          <div className="flex-1">
            <h2 className="text-xl font-bold text-gray-900 md:text-2xl">Common Appliance Problems We Fix</h2>
            <ul className="mt-4 flex flex-col gap-3">
              {commonRepairs.map((item) => (
                <li key={item.appliance} className="text-sm leading-relaxed text-gray-700">
                  <span className="font-semibold text-gray-900">{item.appliance}:</span> {item.issues}
                </li>
              ))}
            </ul>
          </div>

          <div className="flex-1">
            <h2 className="text-xl font-bold text-gray-900 md:text-2xl">
              Appliance Repair Service on the South Shore
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-gray-700">
              Our licensed and insured technicians provide residential appliance repair service
              throughout the South Shore and nearby Massachusetts towns, for all major brands.
            </p>
            <p className="mt-3 text-sm leading-relaxed text-gray-700">
              Appliance Pro Care has over 10 years of appliance repair experience and holds EPA Section 608 technician
              certification for refrigerant handling.
            </p>
            <ul className="mt-4 flex flex-wrap gap-2" aria-label="Towns we serve">
              {towns.map((town) => (
                <li
                  key={town}
                  className="rounded-full border border-gray-300 px-3 py-1 text-sm font-medium text-gray-800"
                >
                  {town}, MA
                </li>
              ))}
            </ul>
            <p className="mt-4 text-sm text-gray-700">
              Have questions first?{" "}
              <Link href="/faq" className="font-semibold text-red-700 underline underline-offset-2 hover:text-red-800">
                Read our FAQ
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
